import { createSlice } from "@reduxjs/toolkit";
import { getFeedbackLogs } from "../services/customer-feedback-services";

const initialState = {
  customerFeedbacks: [],
  customerFeedback: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const customerFeedbackSlice = createSlice({
  name: "customer_feedback",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackLogs.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFeedbackLogs.fulfilled, (state, action) => {
        state.customerFeedbacks = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;

      })
      .addCase(getFeedbackLogs.rejected, (state, action) => {
        state.loading = false;
      })

  },
});
export const { resetSuccess, resetState, resetError } = customerFeedbackSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export default customerFeedbackSlice.reducer;
